(() => {
  'use strict';
  if (window.MWSizeChart) return;
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
  const normalize = value => String(value == null ? '' : value).trim().toUpperCase().replace(/^2XL$/, 'XXL').replace(/^3XL$/, 'XXXL').replace(/^4XL$/, 'XXXXL').replace(/^5XL$/, 'XXXXXL').replace(/YEARS?$/, 'Y').replace(/^FREE[- ]?SIZE$/, 'ONE SIZE').replace(/\s+/g, '');
  const round = value => Math.round(value * 10) / 10;

  // First line holds the column headers, every later line one size. Values are centimetres.
  function parseChart(text) {
    const lines = String(text || '').split(/\r?\n/).map(line => line.trim()).filter(Boolean);
    if (lines.length < 2) return null;
    const headers = lines[0].split('|').map(cell => cell.trim());
    if (headers.length < 2) return null;
    const rows = lines.slice(1).map(line => {
      const cells = line.split('|').map(cell => cell.trim());
      while (cells.length < headers.length) cells.push('');
      return cells.slice(0, headers.length);
    }).filter(cells => cells[0]);
    return rows.length ? { headers, rows } : null;
  }

  function parseDefinitions(text) {
    const map = new Map();
    for (const line of String(text || '').split(/\r?\n/)) {
      const index = line.indexOf('|');
      if (index < 0) continue;
      const name = line.slice(0, index).trim(), copy = line.slice(index + 1).trim();
      if (name && copy) map.set(normalize(name), { name, copy });
    }
    return map;
  }

  // Shows values in inches by converting every number in the measurement columns.
  function convert(value, unit) {
    if (unit === 'cm') return value;
    return value.replace(/\d+(?:\.\d+)?/g, match => String(round(Number(match) / 2.54)));
  }

  function productSizes(section) {
    const node = $('[data-product-json]', section);
    if (!node) return null;
    let product;
    try { product = JSON.parse(node.textContent); } catch (error) { return null; }
    const index = (product.options || []).findIndex(option => /size/i.test(typeof option === 'string' ? option : option && option.name));
    if (index < 0) return null;
    const sizes = (product.variants || []).map(variant => normalize(variant.options[index]));
    return sizes.length ? new Set(sizes) : null;
  }

  function selectedSize(section) {
    const field = $$('[data-option-index]', section).find(node => {
      const legend = $('legend', node);
      return legend && /size/i.test(legend.childNodes[0].textContent);
    });
    const checked = field && $('input:checked', field);
    return checked ? normalize(checked.value) : '';
  }

  function render(dialog) {
    const section = dialog.closest('[data-product-section]');
    const configNode = $('[data-size-config]', dialog);
    if (!section || !configNode) return;
    let config;
    try { config = JSON.parse(configNode.textContent); } catch (error) { return; }

    const chart = parseChart(config.rows);
    const table = $('[data-size-table]', dialog);
    const wrap = $('[data-size-table-wrap]', dialog);
    const units = $('[data-size-units]', dialog);
    const empty = $('[data-size-empty]', dialog);
    const note = $('[data-size-note]', dialog);
    const hint = $('[data-size-scroll-hint]', dialog);
    const unit = dialog.dataset.sizeUnit === 'in' ? 'in' : 'cm';

    const offeredSizes = productSizes(section);
    const rows = chart ? chart.rows.filter(cells => !config.isReference || (offeredSizes && offeredSizes.has(normalize(cells[0])))) : [];
    table.replaceChildren();
    if (rows.length) {
      const head = document.createElement('thead');
      const headRow = document.createElement('tr');
      chart.headers.forEach((header, index) => {
        const cell = document.createElement('th');
        cell.scope = 'col';
        cell.textContent = index === 0 && config.sizeAxis ? config.sizeAxis : header === 'CM' && unit === 'in' ? 'IN' : header;
        headRow.append(cell);
      });
      head.append(headRow);
      const body = document.createElement('tbody');
      rows.forEach(cells => {
        const row = document.createElement('tr');
        cells.forEach((value, index) => {
          const cell = document.createElement(index === 0 ? 'th' : 'td');
          if (index === 0) {
            cell.scope = 'row';
            cell.textContent = value;
          } else {
            const shouldConvert = !Array.isArray(config.conversionColumns) || config.conversionColumns.includes(index);
            cell.textContent = shouldConvert ? convert(value, unit) : value;
          }
          row.append(cell);
        });

        body.append(row);
      });
      table.append(head, body);
    }

    const hasNumbers = rows.some(cells => cells.slice(1).some(value => /\d/.test(value)));
    wrap.hidden = !rows.length;
    if (units) units.hidden = !rows.length || !hasNumbers;
    if (empty) empty.hidden = rows.length > 0;
    if (note) note.hidden = !rows.length;
    if (hint) hint.hidden = !rows.length;

    renderMeasurements(dialog, chart, config);
  }

  // Pairs each measurement column with its description, keeping the chart the single source of names.
  function renderMeasurements(dialog, chart, config) {
    const list = $('[data-size-measure-list]', dialog);
    if (!list) return;
    const definitions = parseDefinitions(config.definitions);
    const headers = chart ? chart.headers.slice(1) : [];
    const items = [];
    for (const header of headers) {
      const definition = definitions.get(normalize(header));
      if (definition) items.push({ name: header, copy: definition.copy });
    }
    if (!items.length) for (const definition of definitions.values()) items.push({ name: definition.name, copy: definition.copy });
    list.replaceChildren();
    items.forEach(item => {
      const entry = document.createElement('li');
      const strong = document.createElement('strong');
      strong.textContent = item.name;
      const copy = document.createElement('span');
      copy.textContent = '— ' + item.copy;
      entry.append(strong, copy);
      list.append(entry);
    });
    const tab = $('[data-size-tab="measure"]', dialog);
    const panel = $('[data-size-panel="measure"]', dialog);
    const hasContent = items.length > 0 || !!$('.mw-size-diagram', dialog);
    if (tab) tab.hidden = !hasContent;
    if (!hasContent && panel && tab && tab.getAttribute('aria-selected') === 'true') showTab(dialog, 'guide');
  }

  function showTab(dialog, name) {
    $$('[data-size-tab]', dialog).forEach(tab => {
      const selected = tab.dataset.sizeTab === name;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
    });
    $$('[data-size-panel]', dialog).forEach(panel => { panel.hidden = panel.dataset.sizePanel !== name; });
    dialog.scrollTop = 0;
  }

  // Keep the size guide usable without the global theme controller.
  function bindDialog(dialog) {
    if (dialog.dataset.mwSizeBound) return;
    dialog.dataset.mwSizeBound = 'true';
    dialog.addEventListener('cancel', event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeSize(dialog);
    }, true);
    dialog.addEventListener('close', () => {
      dialog.mwSizeFinishClose?.(false);
      if (!document.querySelector('dialog[open]')) {
        document.documentElement.style.overflow = '';
        dialog.returnFocus?.focus?.({ preventScroll: true });
      }
    });
  }

  function openSize(dialog, trigger) {
    bindDialog(dialog);
    dialog.mwFinishClose?.(false);
    dialog.mwSizeFinishClose?.(false);
    dialog.classList.remove('is-closing');
    dialog.returnFocus = trigger;
    showTab(dialog, 'guide');
    render(dialog);
    if (!dialog.open) dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    $('[data-close]', dialog)?.focus({ preventScroll: true });
  }

  function closeSize(dialog) {
    if (!dialog.open || dialog.mwSizeFinishClose) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
      dialog.close();
      return;
    }
    dialog.classList.add('is-closing');
    const finish = close => {
      clearTimeout(timer);
      dialog.removeEventListener('animationend', onEnd);
      dialog.mwSizeFinishClose = null;
      dialog.classList.remove('is-closing');
      if (close && dialog.open) dialog.close();
    };
    const onEnd = event => {
      if (event.target === dialog && event.animationName === 'mw-size-fade-out') finish(true);
    };
    const timer = setTimeout(() => finish(true), 320);
    dialog.mwSizeFinishClose = finish;
    dialog.addEventListener('animationend', onEnd);
  }

  // Capture only size-guide open/close actions so the global controller cannot double-handle them.
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-open-size]');
    if (opener) {
      const section = opener.closest('[data-product-section]');
      const dialog = section && $('[data-size-modal]', section);
      if (!dialog) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      openSize(dialog, opener);
      return;
    }
    const dialog = event.target.closest('[data-size-modal]');
    if (!dialog) return;
    const close = event.target.closest('[data-close]');
    const bounds = dialog.getBoundingClientRect();
    const outside = event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom);
    if (close || outside) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeSize(dialog);
    }
  }, true);

  function renderAll(scope = document) {
    $$('[data-size-modal]', scope).forEach(dialog => {
      if ($('[data-size-config]', dialog)) { bindDialog(dialog); render(dialog); }
    });
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('button');
    if (!button) return;
    if (button.hasAttribute('data-open-size')) {
      const section = button.closest('[data-product-section]');
      const dialog = section && $('[data-size-modal]', section);
      if (!dialog || !$('[data-size-config]', dialog)) return;
      showTab(dialog, 'guide');
      render(dialog);
      return;
    }
    const dialog = button.closest('[data-size-modal]');
    if (!dialog) return;
    if (button.dataset.sizeTab) showTab(dialog, button.dataset.sizeTab);
    if (button.dataset.sizeUnit) {
      dialog.dataset.sizeUnit = button.dataset.sizeUnit;
      $$('[data-size-unit]', dialog).forEach(node => node.setAttribute('aria-pressed', String(node === button)));
      render(dialog);
    }
  });

  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-size-tab]');
    if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    event.preventDefault();
    const dialog = tab.closest('[data-size-modal]');
    const tabs = $$('[data-size-tab]', dialog).filter(node => !node.hidden);
    let index = tabs.indexOf(tab);
    index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    showTab(dialog, tabs[index].dataset.sizeTab);tabs[index].focus();
  });
  document.addEventListener('shopify:section:load', event => renderAll(event.target));
  window.MWSizeChart = { render: renderAll, parseChart, convert };
  renderAll();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => renderAll(), { once: true });
})();
